/**
 * Data loading for a single article at /blog/{slug}.
 *
 * Deliberately thin: it resolves the slug to a Console page id and hands off to
 * the same `fetchPageAssets` that `/p/:pageId` uses. Sharing that path means an
 * article gets the store's caching, its 404 handling and its fallback
 * behaviour for free, and there is only one place where page assets are
 * fetched rather than two that can drift.
 */

import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { assetPathForSlug, pageIdFromSlug } from '../../util/blogPages';

export const loadData = params => dispatch => {
  const slug = params?.slug;
  const pageId = pageIdFromSlug(slug);
  const assetPath = assetPathForSlug(slug);

  // A slug that cannot be a page id cannot name an article. Resolving without
  // dispatching lets the component render its own not-found rather than
  // sending a malformed path to the asset store.
  if (!pageId || !assetPath) {
    return Promise.resolve({});
  }

  const hasFallbackContent = false;
  return dispatch(fetchPageAssets({ [pageId]: assetPath }, hasFallbackContent));
};
